import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { ISurveySimple } from 'types/interfaces';

export interface ISurveyState {
    allSurveys: Array<ISurveySimple>;
    lastGenericSurvey: ISurveySimple | null;
    flagNewSurveys: boolean;
}

const initialState: ISurveyState = {
   allSurveys: [],
   lastGenericSurvey: null,
   flagNewSurveys: false,
};

export const surveySlice = createSlice({
  name: 'surveySlice',
  initialState,
  reducers: {
    updateSurveys: (state, action) => {
      state.allSurveys = action.payload;
    },
    updateFlagSurveys: (state, action) => {
      state.flagNewSurveys = action.payload;
    },
    updateLastGenericSurvey: (state, action) => {
      state.lastGenericSurvey = action.payload;
    }
  },
});

export const { updateSurveys, updateFlagSurveys, updateLastGenericSurvey } = surveySlice.actions;

export const surveysState = (state: RootState) => state.surveySlice;

export default surveySlice.reducer;